<script>
    import {map} from "lodash";
    import {selectPageInParentWindow} from "./pageUtils";

    const BlogPostsRepository = RepositoryFactory.get("blogPosts");
    import {RepositoryFactory} from "src/api/repositories/RepositoryFactory";

    export default {
        namespaced: true,
        state: {
            blogPosts: [],
            blogPostsPages: 0, // Holds the total number of blog post pages
            // blogPostPaginated: [], // Holds the blog posts
            blogPostPagesFetched: [], // Holds the Current Page, 0 when we have no data
            lastBlogPostPageFetched: 0, // Holds the last page number that was fetched
            fetchingBlogPostsPage: [], // id of blog posts that are being fetched
            totalBlogPostItems: 0, // Holds the total number of blog post items,
            blogPostTemplates: null
        },
        actions: {
            retrieveBlogPosts({commit, dispatch}){
                return BlogPostsRepository.blogPosts({"site_template": true}).then((result)=>{
                    if(result.data.success){
                            return dispatch('setBlogPosts',result.data.blogPosts); 
                    }
                })
            },
            setBlogPosts({commit}, payload) {                
                commit("setBlogPosts", payload);
            },
            addBlogPostsPaginated({commit}, payload) {
                commit("addBlogPostsPaginated", payload);
            },
            getBlogPostPaginated({commit, dispatch, state}, page) {
                if (!page) {
                    page = state.lastBlogPostPageFetched + 1;
                }

                commit("addToFetchingBlogPages", page);
                params = {
                    "site_template" : true
                };
                return BlogPostsRepository.getBlogPosts(page,params).then(
                    (response) => {
                        if (response.data.success) {
                            commit("removeFromFetchingBlogPages", page);
                            commit("addToFetchedBlogPages", page);
                            commit("setLastBlogPostPageFetched", page);
                            commit(
                                "addBlogPostsPaginated",
                                response.data.blogPosts
                            );
                            commit(
                                "setBlogPostsPages",
                                response.data.pagination.totalPages
                            );
                            commit(
                                "setCurrentBlogPostsPage",
                                response.data.pagination.page
                            );
                            commit(
                                "setTotalBlogPostItems",
                                response.data.pagination.totalItems
                            );
                            console.log(response.data.blogPosts);
                            return response.data.blogPosts;
                        }
                    },
                    (err) => {
                        commit("setGetBlogPostPaginatedRequestInProgress", false);
                        console.log(err);
                    }
                );
            },
            deleteBlogPost(
                {state, commit, rootState, dispatch},
                {slug, siteTemplate}
            ) {
                if (
                    siteTemplate === rootState.siteTemplate.currentSiteTemplate &&
                    rootState.pages.pageContext.params &&
                    rootState.pages.pageContext.params.slug === slug
                ) {
                    const pageData = {
                        slug: "home",
                        type: "home",
                        site_template: rootState.siteTemplate.currentSiteTemplate,
                    };

                    if (window.parent.parentVue) {
                        selectPageInParentWindow(pageData);
                    } else {
                        dispatch("pages/selectPage", pageData, {root: true});
                    }

                    dispatch(
                        "pages/setPageContext",
                        {
                            slug: "home",
                            type: "home",
                        },
                        {root: true}
                    );
                }
                const params = {
                    "site_template" : true
                }
                return BlogPostsRepository.deleteBlogPost(slug, params);
            },
            cloneBlogPost({state, commit, rootState, dispatch}, payload) {
                const params = {
                    "site_template" : true
                };
                return BlogPostsRepository.cloneBlogPost(payload,params).then((response) => {
                    if (response.data.success) {
                        const postData = {
                            slug: response.data.cloneData.slug,
                            type: "blog_post",
                            site_template: rootState.siteTemplate.currentSiteTemplate,
                        };

                        if (window.parent.parentVue) {
                            selectPageInParentWindow(postData);
                        } else {
                            dispatch("pages/selectPage", postData, {root: true});
                        }
                    } else {
                        displayError(response.data.errors)
                    }

                });
            },
            createBlogPost({state, commit, rootState, dispatch}, data) {
                data['site_template'] = rootState.siteTemplate.currentSiteTemplate;
                return BlogPostsRepository.createBlogPost(data).then((response) => {
                    if (response.data.success) {
                        const pageData = {
                            slug: response.data.blogPost.slug,
                            type: "blog_post",
                            site_template: rootState.siteTemplate.currentSiteTemplate,
                        };
                        if (window.parent.parentVue) {
                            selectPageInParentWindow(pageData);
                        } else {
                            dispatch("pages/selectPage", pageData, {root: true});
                        }
                    } else {
                        return Promise.reject(response.data.errors)
                    }
                });
            },
            getBlogPostTemplates({state, commit}) {
                if (state.blogPostTemplates) {
                    return Promise.resolve(state.blogPostTemplates)
                }

                return BlogPostsRepository.getBlogPostTemplates().then((response) => {
                    if (response.data.success) {
                        commit('setBlogPostTemplates', response.data.blogPostTemplates)
                        return response.data.blogPostTemplates;
                    }
                });
            }
        },
        getters: {
            blogPostsQuery() {
                return BlogPostsRepository.getBlogPostsQuery;
            }
        },
        mutations: {
            setBlogPosts(state, blogPosts) {
                state.blogPosts = map(blogPosts, (v, UID) => ({
                    UID,
                    ...v,
                    type: "blog_post",
                }));
            },
            setBlogPostsPages(state, pages) {
                state.blogPostsPages = pages;
            },
            addBlogPostPage(state, newBlogPostsPage) {
                state.blogPostPaginated = state.blogPostPaginated.concat(
                    newBlogPostsPage
                );
            },
            setCurrentBlogPostsPage(state, page) {
                state.currentBlogPostsPage = page;
            },
            setTotalBlogPostItems(state, total) {
                state.totalBlogPostItems = total;
            },
            setLastBlogPostPageFetched(state, page) {
                state.lastBlogPostPageFetched = page;
            },
            addToFetchingBlogPages(state, page) {
                if (!state.fetchingBlogPostsPage.includes(page)) {
                    state.fetchingBlogPostsPage.push(value);
                }
            },
            addToFetchedBlogPages(state, page) {
                if (!state.blogPostPagesFetched.includes(page)) {
                    state.blogPostPagesFetched.push(value);
                }
            },
            removeFromFetchingBlogPages(state, page) {
                if (state.fetchingBlogPostsPage.includes(page)) {
                    state.fetchingBlogPostsPage.splice(state.fetchingBlogPostsPage.indexOf(page), 1);
                }
            },
            addToFetchedBlogPages(state, page) {
                if (!state.blogPostPagesFetched.includes(page)) {
                    state.blogPostPagesFetched.push(value);
                }
            },
            removeFromFetchingBlogPages(state, page) {
                if (state.fetchingBlogPostsPage.includes(page)) {
                    state.fetchingBlogPostsPage.splice(
                        state.fetchingBlogPostsPage.indexOf(page),
                        1
                    );
                }
            },
        },
    };
</script>
